/** Departure — the tour, the local date and departure time (in the tour's zone, which
 *  the panel header names), the trip end, the departure code and the booking notes the
 *  guide sees; the UTC start, zone, bespoke flag and departure tag as System. */
import type { BookingRecordStage } from '@/api/bookingRecord';
import type { ViewSection } from '@/features/records/views/types';

import type { BookingDisplayContext } from './displays';
import { PanelMeta } from './PanelMeta';
import { StagePanel } from './StagePanel';

export function DeparturePanel({
  section,
  display,
}: {
  section: ViewSection<BookingRecordStage>;
  display: BookingDisplayContext;
}) {
  return <StagePanel section={section} display={display} meta={<PanelMeta>Times in {display.tz}</PanelMeta>} />;
}
